<template>
    <div class="repeater-section mb-4">
        <h3>{{repeaterName}}</h3>
        <div class="repeater-field" v-for="(input, index) in inputs" :key="index">
            <div class="input-group">
                <input :name="input.name" v-model="input.value" type="text" class="form-control" aria-describedby="helpId">
                <div class="input-group-append" v-if="count !== 1">
                    <span @click="removeField(input)" class="input-group-text"><i class="fa fa-times"></i></span>
                </div>
            </div>
        </div>
        <div class="control-container">
            <button @click="addField()" class="btn btn-primary">+ {{repeaterButtonLabel}}</button>
        </div>
    </div>
</template>

<script>
import InputText from './form-text.vue';
export default {
    name: 'form-input-repeater',
    components: {
        'input-text': InputText
    },
    props: {
        repeaterName: "",
        repeaterButtonLabel: "",
        inputs: {
            
        }
    },
    data() {
        return {
            count: 1
        }
    },
    mounted() {
        this.count = this.inputs.length;
    },
    methods: {
        addField() {
            this.count++;
            this.inputs.push({
                type: 'text',
                name: 'repeater-field-'+this.count,
                value: null,
            });
        },
        removeField(input) {
            if(this.inputs.length == 1){
                return;
            }
            this.count--;
            this.inputs.splice(this.inputs.indexOf(input), 1);            
        }
    }
}
</script>

<style scoped lang="scss">
    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }

    .repeater-section{
        padding:15px;
        border-radius: 3px;
        border:1px solid #dedede;
        .repeater-field{
            margin-bottom: 15px;
        }
        .control-container{
            text-align: right;
        }
        .input-group-append .input-group-text{
            border-color: #AB5755 !important;
            background-color: #AB5755 !important;
            color:white;
        }
    }
</style>

